<template lang="pug">
div
  v-row.monitorsys-row
    v-col(
      v-for="card in summaryCards",
      :key="card.key",
      class="dispositivos-summary-col",
      cols="12",
      sm="6",
      md="4"
    )
      summary-card(
        :title="card.title",
        :value="card.value",
        :icon="card.icon",
        :variant="card.variant",
        :icon-variant="card.iconVariant"
      )

  v-row.monitorsys-row
    v-col(cols="12", md="6")
      v-card.panel-card(outlined)
        .panel-card__header
          span.panel-card__title Distribuição por sistema operacional
          v-btn.panel-card__expand(
            outlined,
            small,
            class="monitorsys-action-button",
            @click="dialogs.distribuicao = true"
          )
            v-icon(small) mdi-arrow-expand
        v-card-text.panel-card__content
          apexchart(
            v-if="distribuicaoSeries.length",
            type="bar",
            :options="distribuicaoChartOptions",
            :series="distribuicaoSeries",
            height="100%"
          )
          .panel-card__empty(v-else)
            span Nenhum dado encontrado para o período selecionado.

    v-col(cols="12", md="6")
      v-card.panel-card(outlined)
        .panel-card__header
          span.panel-card__title Evolução de uso mobile
          v-btn.panel-card__expand(
            outlined,
            small,
            class="monitorsys-action-button",
            @click="dialogs.evolucao = true"
          )
            v-icon(small) mdi-arrow-expand
        v-card-text.panel-card__content
          apexchart(
            v-if="evolucaoSeries.length",
            :key="evolucaoRenderKey",
            type="line",
            :options="evolucaoChartOptions",
            :series="evolucaoSeries",
            height="100%"
          )
          .panel-card__empty(v-else)
            span Nenhum dado encontrado para o período selecionado.

  v-row.monitorsys-row
    v-col(cols="12")
      v-card.panel-card(outlined)
        .panel-card__header
          span.panel-card__title Modelos de dispositivos mais usados
          v-btn.panel-card__expand(
            outlined,
            small,
            class="monitorsys-action-button",
            @click="dialogs.topModelos = true"
          )
            v-icon(small) mdi-arrow-expand
        v-card-text.panel-card__content
          apexchart(
            v-if="topModelosSeries.length",
            type="bar",
            :options="topModelosChartOptions",
            :series="topModelosSeries",
            height="100%"
          )
          .panel-card__empty(v-else)
            span Nenhum dado encontrado para o período selecionado.

  v-dialog(
    :value="dialogs.distribuicao",
    @input="dialogs.distribuicao = $event",
    content-class="monitorsys-dialog-content",
    max-width="1200px",
    width="1200px"
  )
    v-card.panel-dialog
      .panel-card__header.panel-card__header--dialog
        span.panel-card__title Distribuição por sistema operacional
        v-btn(icon, @click="dialogs.distribuicao = false")
          v-icon mdi-close
      v-card-text.panel-card__dialog-content.panel-card__dialog-content--scroll
        apexchart(
          v-if="distribuicaoSeries.length",
          type="bar",
          :options="distribuicaoDialogOptions",
          :series="distribuicaoSeries",
          height="520"
        )
        .panel-card__empty(v-else)
          span Nenhum dado encontrado para o período selecionado.

  v-dialog(
    :value="dialogs.evolucao",
    @input="dialogs.evolucao = $event",
    content-class="monitorsys-dialog-content",
    max-width="1200px",
    width="1200px"
  )
    v-card.panel-dialog
      .panel-card__header.panel-card__header--dialog
        span.panel-card__title Evolução de uso mobile
        v-btn(icon, @click="dialogs.evolucao = false")
          v-icon mdi-close
      v-card-text.panel-card__dialog-content.panel-card__dialog-content--scroll
        apexchart(
          v-if="evolucaoSeries.length",
          :key="evolucaoDialogRenderKey",
          type="line",
          :options="evolucaoDialogOptions",
          :series="evolucaoSeries",
          height="520"
        )
        .panel-card__empty(v-else)
          span Nenhum dado encontrado para o período selecionado.

  v-dialog(
    :value="dialogs.topModelos",
    @input="dialogs.topModelos = $event",
    content-class="monitorsys-dialog-content",
    max-width="1200px",
    width="1200px"
  )
    v-card.panel-dialog
      .panel-card__header.panel-card__header--dialog
        span.panel-card__title Top dispositivos (modelo)
        v-btn(icon, @click="dialogs.topModelos = false")
          v-icon mdi-close
      v-card-text.panel-card__dialog-content.panel-card__dialog-content--scroll
        apexchart(
          v-if="topModelosDialogSeries.length",
          type="bar",
          :options="topModelosDialogOptions",
          :series="topModelosDialogSeries",
          :height="topModelosDialogHeight"
        )
        .panel-card__empty(v-else)
          span Nenhum dado encontrado para o período selecionado.
</template>

<script>
import SummaryCard from "@/components/dashboards/shared/SummaryCard";

const OS_COLORS = {
  Dispositivos: "#3b4c63",
  Usuários: "#1e88e5",
  Modelos: "#2e7d32",
  "Ativos hoje": "#ff9f1c"
};
const EVOLUTION_COLORS = {
  ativos: "#1e88e5",
  novos: "#2e7d32"
};
const TOP_MODELOS_COLOR = "#3b4c63";
const INITIAL_TOP_MODELOS_LIMIT = 10;
const RANKING_DIALOG_MIN_HEIGHT = 520;
const RANKING_DIALOG_BAR_HEIGHT = 40;
const NUMBER_FORMATTER = new Intl.NumberFormat("pt-BR");

function toNumber(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function toArray(value) {
  return Array.isArray(value) ? value : [];
}

function sortByTotalDesc(items) {
  return toArray(items)
    .map((item, index) => ({ item, index }))
    .sort((a, b) => {
      const diff =
        toNumber((b.item && b.item.total) || 0) - toNumber((a.item && a.item.total) || 0);
      if (diff !== 0) return diff;
      return a.index - b.index;
    })
    .map(entry => entry.item);
}

function formatInteger(value) {
  return NUMBER_FORMATTER.format(Math.round(toNumber(value)));
}

function formatTimestampBR(value) {
  if (value === null || value === undefined || value === "") return "";

  const raw =
    typeof value === "number"
      ? value
      : typeof value === "string" && /^\d+$/.test(value)
      ? Number(value)
      : value;

  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return "";

  const day = String(parsed.getDate()).padStart(2, "0");
  const month = String(parsed.getMonth() + 1).padStart(2, "0");
  const year = parsed.getFullYear();
  return `${day}/${month}/${year}`;
}

function normalizeModelName(value) {
  const normalized = String(value || "").trim();
  if (!normalized) return "Não identificado";

  const lower = normalized.toLowerCase();
  if (lower === "null" || lower === "undefined") {
    return "Não identificado";
  }

  return normalized;
}

function createDistribuicaoOptions(chartHeight, categories) {
  return {
    chart: {
      type: "bar",
      height: chartHeight,
      parentHeightOffset: 0,
      toolbar: { show: false }
    },
    colors: [
      OS_COLORS["Dispositivos"],
      OS_COLORS["Usuários"],
      OS_COLORS["Modelos"],
      OS_COLORS["Ativos hoje"]
    ],
    plotOptions: {
      bar: { borderRadius: 4, columnWidth: "70%" }
    },
    dataLabels: { enabled: false },
    grid: { borderColor: "#dfe7f5", strokeDashArray: 4 },
    legend: { show: true, position: "top", horizontalAlign: "center" },
    xaxis: {
      categories,
      labels: { style: { colors: "#5f6b7a", fontSize: "12px" } }
    },
    yaxis: {
      min: 0,
      labels: {
        formatter: value => formatInteger(value),
        style: { colors: "#5f6b7a", fontSize: "12px" }
      }
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: { formatter: value => formatInteger(value) }
    }
  };
}

function createEvolucaoOptions(chartHeight, tickAmount) {
  return {
    chart: {
      type: "line",
      height: chartHeight,
      parentHeightOffset: 0,
      toolbar: { show: false },
      zoom: { enabled: false }
    },
    colors: [EVOLUTION_COLORS.ativos, EVOLUTION_COLORS.novos],
    stroke: { curve: "monotoneCubic", width: 2.5 },
    markers: { size: 2.5, strokeWidth: 0, hover: { size: 4 } },
    grid: {
      borderColor: "#dfe7f5",
      strokeDashArray: 4
    },
    dataLabels: { enabled: false },
    legend: { show: true, position: "top", horizontalAlign: "center" },
    xaxis: {
      type: "datetime",
      tickAmount,
      axisBorder: { show: true },
      axisTicks: { show: true },
      crosshairs: { show: true },
      tooltip: { enabled: false },
      labels: {
        rotate: 0,
        datetimeUTC: false,
        formatter: value => formatTimestampBR(value),
        style: { colors: "#5f6b7a", fontSize: "12px" }
      }
    },
    yaxis: {
      min: 0,
      forceNiceScale: true,
      labels: {
        formatter: value => formatInteger(value),
        style: { colors: "#5f6b7a", fontSize: "12px" }
      }
    },
    tooltip: {
      enabled: true,
      shared: true,
      intersect: false,
      followCursor: false,
      x: { formatter: value => formatTimestampBR(value) },
      y: { formatter: value => `${formatInteger(value)} dispositivos` }
    }
  };
}

function createTopModelosOptions(chartHeight, categories) {
  return {
    chart: {
      type: "bar",
      height: chartHeight,
      parentHeightOffset: 0,
      toolbar: { show: false }
    },
    colors: [TOP_MODELOS_COLOR],
    plotOptions: {
      bar: { horizontal: true, borderRadius: 4, barHeight: "66%" }
    },
    dataLabels: {
      enabled: true,
      formatter: value => formatInteger(value),
      style: {
        colors: [TOP_MODELOS_COLOR],
        fontSize: "12px",
        fontWeight: 600
      },
      background: {
        enabled: true,
        foreColor: "#fff",
        borderRadius: 4,
        padding: 10,
        opacity: 0.8,
        borderWidth: 1,
        borderColor: "#d4dce8"
      }
    },
    grid: { borderColor: "#dfe7f5", strokeDashArray: 4 },
    legend: { show: false },
    xaxis: {
      categories,
      labels: {
        formatter: value => formatInteger(value),
        style: { colors: "#5f6b7a", fontSize: "12px" }
      }
    },
    yaxis: {
      labels: {
        maxWidth: 260,
        style: { colors: "#3d4b63", fontSize: "12px" }
      }
    },
    tooltip: {
      intersect: false,
      y: { formatter: value => `${formatInteger(value)} dispositivos` }
    }
  };
}

export default {
  name: "DispositivosTab",

  components: {
    SummaryCard
  },

  props: {
    isActive: { type: Boolean, default: false },
    totais: {
      type: Object,
      default: () => ({ total: 0, android: 0, ios: 0, windows: 0, ativosHoje: 0 })
    },
    distribuicaoSO: { type: Array, default: () => [] },
    evolucao: { type: Array, default: () => [] },
    topModelos: { type: Array, default: () => [] }
  },

  data() {
    return {
      chartRefreshTick: 0,
      dialogs: {
        distribuicao: false,
        evolucao: false,
        topModelos: false
      }
    };
  },

  computed: {
    summaryCards() {
      return [
        {
          key: "total-dispositivos",
          title: "Total de dispositivos",
          value: formatInteger(this.totais.total),
          variant: "primary"
        },
        {
          key: "total-android",
          title: "Total Android",
          value: formatInteger(this.totais.android),
          variant: "neutral",
          icon: "mdi-android",
          iconVariant: "android"
        },
        {
          key: "total-ios",
          title: "Total iOS",
          value: formatInteger(this.totais.ios),
          variant: "neutral",
          icon: "mdi-apple",
          iconVariant: "ios"
        },
        {
          key: "total-windows",
          title: "Total Windows",
          value: formatInteger(this.totais.windows),
          variant: "neutral",
          icon: "mdi-microsoft-windows",
          iconVariant: "windows"
        },
        {
          key: "ativos-hoje",
          title: "Dispositivos ativos hoje",
          value: formatInteger(this.totais.ativosHoje),
          variant: "warning"
        }
      ];
    },

    distribuicaoCategories() {
      return toArray(this.distribuicaoSO).map(item => item.categoria);
    },

    distribuicaoSeries() {
      const items = toArray(this.distribuicaoSO);
      if (!items.length) return [];
      const pluck = key => items.map(item => toNumber(item[key]));
      const series = [
        { name: "Dispositivos", data: pluck("dispositivos") },
        { name: "Usuários", data: pluck("usuarios") },
        { name: "Modelos", data: pluck("modelos") },
        { name: "Ativos hoje", data: pluck("ativosHoje") }
      ];
      const hasAnyValue = series.some(s => s.data.some(v => v > 0));
      return hasAnyValue ? series : [];
    },

    distribuicaoChartOptions() {
      return createDistribuicaoOptions("100%", this.distribuicaoCategories);
    },

    distribuicaoDialogOptions() {
      return createDistribuicaoOptions(520, this.distribuicaoCategories);
    },

    evolucaoSeries() {
      const items = toArray(this.evolucao);
      if (!items.length) return [];
      const toPoints = key =>
        items.map(item => ({
          x: `${item.data}T12:00:00`,
          y: toNumber(item[key])
        }));
      return [
        { name: "Ativos por dia", data: toPoints("ativos") },
        { name: "Novos por dia", data: toPoints("novos") }
      ];
    },

    evolucaoTickAmount() {
      return Math.min(Math.max(1, toArray(this.evolucao).length - 1), 8);
    },

    evolucaoChartOptions() {
      return createEvolucaoOptions("100%", this.evolucaoTickAmount);
    },

    evolucaoDialogOptions() {
      return createEvolucaoOptions(520, this.evolucaoTickAmount);
    },

    evolucaoRenderKey() {
      return ["preview", this.chartRefreshTick].join("|");
    },

    evolucaoDialogRenderKey() {
      return ["dialog", this.chartRefreshTick].join("|");
    },

    topModelosItems() {
      const items = toArray(this.topModelos)
        .filter(item => item)
        .map(item => ({
          ...item,
          modelo: normalizeModelName(item.modelo)
        }));
      return sortByTotalDesc(items);
    },

    topModelosCategories() {
      return this.topModelosItems.slice(0, INITIAL_TOP_MODELOS_LIMIT).map(item => item.modelo);
    },

    topModelosSeries() {
      if (!this.topModelosItems.length) return [];
      return [
        {
          name: "Dispositivos",
          data: this.topModelosItems
            .slice(0, INITIAL_TOP_MODELOS_LIMIT)
            .map(item => toNumber(item.total))
        }
      ];
    },

    topModelosDialogCategories() {
      return this.topModelosItems.map(item => item.modelo);
    },

    topModelosDialogSeries() {
      if (!this.topModelosItems.length) return [];
      return [
        {
          name: "Dispositivos",
          data: this.topModelosItems.map(item => toNumber(item.total))
        }
      ];
    },

    topModelosChartOptions() {
      return createTopModelosOptions("100%", this.topModelosCategories);
    },

    topModelosDialogOptions() {
      return createTopModelosOptions(this.topModelosDialogHeight, this.topModelosDialogCategories);
    },

    topModelosDialogHeight() {
      return Math.max(
        RANKING_DIALOG_MIN_HEIGHT,
        this.topModelosDialogCategories.length * RANKING_DIALOG_BAR_HEIGHT
      );
    }
  },

  methods: {
    refreshCharts() {
      this.chartRefreshTick += 1;
    }
  },

  watch: {
    isActive(value) {
      if (!value) return;
      this.$nextTick(() => this.refreshCharts());
    },

    evolucao() {
      this.$nextTick(() => this.refreshCharts());
    }
  },

  mounted() {
    if (this.isActive) {
      this.$nextTick(() => this.refreshCharts());
    }
  }
};
</script>

<style scoped>
.monitorsys-row {
  margin-left: -6px !important;
  margin-right: -6px !important;
}

.monitorsys-row > [class*="col-"] {
  padding: 6px !important;
}

@media (min-width: 1264px) {
  .dispositivos-summary-col {
    flex: 0 0 20%;
    max-width: 20%;
  }
}

.panel-card {
  border-color: #d9e2ef !important;
  box-shadow: 0 2px 6px rgba(15, 42, 77, 0.08);
  border-radius: 18px 6px 18px 6px !important;
  display: flex;
  flex-direction: column;
  min-height: 420px;
  height: 420px;
  max-height: 420px;
}

.panel-dialog {
  border-color: #d9e2ef !important;
  border-radius: 10px !important;
  box-shadow: 0 2px 6px rgba(15, 42, 77, 0.08);
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

.panel-card__header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 16px 16px 0;
}

.panel-card__header--dialog {
  flex: 0 0 auto;
  padding: 16px;
}

.panel-card__title {
  color: #0a1f44;
  font-size: 16px;
  font-weight: 700;
}

.panel-card__expand {
  height: 30px !important;
  min-width: 36px !important;
  padding: 0 8px !important;
}

.panel-card__content {
  flex: 1 1 0;
  min-height: 0;
  padding-bottom: 16px !important;
}

.panel-card__dialog-content {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.panel-card__dialog-content--scroll {
  flex: 1 1 auto;
  min-height: 0;
  max-height: none;
  overflow-y: auto;
}

::v-deep .monitorsys-dialog-content .v-dialog {
  margin: 24px auto;
  height: calc(100vh - 48px);
  max-height: calc(100vh - 48px);
}

.panel-card__empty {
  align-items: center;
  color: #5f6b7a;
  display: flex;
  height: 100%;
  justify-content: center;
  min-height: 320px;
  text-align: center;
}

.monitorsys-action-button {
  border-color: #c7d1dc !important;
  box-shadow: none !important;
  color: #6f7d8c !important;
  font-size: 11px !important;
  font-weight: 500;
  letter-spacing: 0.01em !important;
  text-transform: none !important;
}

.monitorsys-action-button::before {
  background-color: transparent !important;
}

.monitorsys-action-button .v-icon {
  color: #748291 !important;
}

@media (max-width: 959px) {
  .panel-card {
    height: auto;
    min-height: 420px;
    max-height: none;
  }

  .panel-card__header {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }

  .panel-card__expand {
    align-self: flex-end;
  }
}
</style>
